import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {VisionStep} from '../message/VisionStep';
import {VisionStepCriteria} from './VisionStepCriteria';
import {VisionStepScenario} from './VisionStepScenario';

export class VisionStepWrapper extends BaseWrapper<VisionStep, VisionStepCriteria, VisionStepScenario>  {}

